var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamersenseiBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1305"
  })), /*#__PURE__*/React.createElement("path", {
    className: "logo-emblem",
    d: "M6.8 6.676H1.3V1.194h5.5v.61H1.911v4.263H6.19V3.02H3.133v.61h2.445v1.827H2.522v-.61h2.445V4.24H2.522V2.412H6.8z",
    fill: "#36f35b",
    id: "path2332",
    style: {
      strokeWidth: 0.999999,
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamersenseiBg);
export default __webpack_public_path__ + "static/media/gamersensei-bg.98fec57921db511cb1085068bccdbf1d.svg";
export { ForwardRef as ReactComponent };